import clsx from "clsx";
import { forwardRef, useMemo } from "react";
import { NavLink } from "react-router-dom";

import { IHelperAdapterNavLinkProps } from "./helper_adapter_navlink.types";

export const HelperAdapterNavLink = forwardRef<
  HTMLAnchorElement,
  IHelperAdapterNavLinkProps
>(({ to, toAlt, activeClassName, className, ...props }, ref) =>
  useMemo(
    () => (
      <NavLink
        ref={ref}
        to={to}
        {...props}
        className={({ isActive }) =>
          clsx(className, isActive && (activeClassName || "active"))
        }
      />
    ),
    [activeClassName, className, props, ref, to],
  ),
);
